import { createFileRoute, Link } from '@tanstack/react-router';

import { Button, PageHeader, PageLayout, Skeleton } from '@keboola/design';
import { ArrowLeft } from '@keboola/design/icons';

import { QueryError } from '../../../../components/QueryError';
import { useAdminApp } from '../../../../features/admin/queries';
import { VersionHistory } from '../../../../features/apps/components/VersionHistory';
import { getAppTitle } from '../../../../features/apps/helpers';

export const Route = createFileRoute('/admin/components/$appId/versions')({
  component: AdminComponentVersionsPage,
  head: () => ({ meta: [{ title: 'Component versions | Keboola Developer Portal admin' }] }),
});

function AdminComponentVersionsPage() {
  const { appId } = Route.useParams();
  const { data: app, isLoading, isError, error, refetch } = useAdminApp(appId);

  return (
    <PageLayout>
      <PageLayout.Header>
        <PageHeader.Detail
          title={app === undefined ? appId : getAppTitle(app)}
          description="Every stored version. Revert to one to restore all of its settings."
          breadcrumbs={
            <Button asChild variant="inline">
              <Link to="/admin/components/$appId" params={{ appId }}>
                <ArrowLeft />
                Back to the component
              </Link>
            </Button>
          }
        />
      </PageLayout.Header>

      {isLoading && <Skeleton className="tw:h-64" />}

      <QueryError
        isError={isError}
        hasData={app !== undefined}
        error={error}
        onRetry={() => void refetch()}
        loadTitle="Could not load this component"
        refreshTitle="Could not refresh this component"
        staleNote="Showing it as of the last successful load."
        titleAs="h2"
      />

      {/* The versions endpoint is vendor-scoped; admins reach it under the component's own vendor. */}
      {app !== undefined && <VersionHistory vendorId={app.vendor.id} appId={appId} />}
    </PageLayout>
  );
}
